// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.share-purchased-match-link-modal__container .modal__container{
    max-width: 545px;
    padding: 32px;
}

.share-purchased-match-link-modal__content{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
}

.share-purchased-match-link-modal__content .hubicon-groups1::before {
    font-size: 40px;
    color: #6EA8FE;
    margin-top: 16px;
}

.share-purchased-match-link-modal__content .baloa-subtitle-2 {
    color: var(--primary-very-dark-color);
}

.share-purchased-match-link-modal__content .baloa-names {
    color: var(--primary-very-dark-color);
    margin-top: 8px;
    font-weight: var(--font-regular);
}

.share-purchased-match-link-modal__buttons{
    width: 100%;
    align-items: center;
    padding: 16px;
    border: 1px solid var(--new-input-background-color);
    border-radius: 8px;
    margin-top: 24px;
}

.share-purchased-match-link-modal__buttons-button {
    margin: 18px auto 0 auto;
}

.share-purchased-match-link-modal__buttons-button.button{
    padding: 8px 12px;
}

.share-purchased-match-link-modal__buttons-button .icon {
    grid-area: icon;
    margin-right: 6px;
    text-align: left;
}

.share-purchased-match-link-modal__buttons-button .icon-copy-86 {
    background-color: unset;
    
}

/* .share-purchased-match-link-modal__link{
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-top: 24px;
    max-width: 80%;
    
} */

.share-purchased-match-link-modal__link.baloa-table{
    background: var(--new-background-color);
    padding: 11px;
    border-radius: 4px;
    white-space: nowrap;
    overflow: hidden;
}


@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .share-purchased-match-link-modal__container .modal__container {
        width: 90vw;
        padding: 14px;
    }

    .share-purchased-match-link-modal__buttons {
        justify-content: center;
    }

}`, "",{"version":3,"sources":["webpack://./src/app/baloa-play/components/baloa-play-share-purchased-match-link-modal/BaloaPlaySharePurchasedMatchLinkModalComponent.styles.css"],"names":[],"mappings":";AACA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mDAAmD;IACnD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;;;;;;;GAOG;;AAEH;IACI,uCAAuC;IACvC,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;;AAGA,yCAAyC,4BAA4B;;IAEjE;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,uBAAuB;IAC3B;;AAEJ","sourcesContent":["\n.share-purchased-match-link-modal__container .modal__container{\n    max-width: 545px;\n    padding: 32px;\n}\n\n.share-purchased-match-link-modal__content{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    text-align: center;\n}\n\n.share-purchased-match-link-modal__content .hubicon-groups1::before {\n    font-size: 40px;\n    color: #6EA8FE;\n    margin-top: 16px;\n}\n\n.share-purchased-match-link-modal__content .baloa-subtitle-2 {\n    color: var(--primary-very-dark-color);\n}\n\n.share-purchased-match-link-modal__content .baloa-names {\n    color: var(--primary-very-dark-color);\n    margin-top: 8px;\n    font-weight: var(--font-regular);\n}\n\n.share-purchased-match-link-modal__buttons{\n    width: 100%;\n    align-items: center;\n    padding: 16px;\n    border: 1px solid var(--new-input-background-color);\n    border-radius: 8px;\n    margin-top: 24px;\n}\n\n.share-purchased-match-link-modal__buttons-button {\n    margin: 18px auto 0 auto;\n}\n\n.share-purchased-match-link-modal__buttons-button.button{\n    padding: 8px 12px;\n}\n\n.share-purchased-match-link-modal__buttons-button .icon {\n    grid-area: icon;\n    margin-right: 6px;\n    text-align: left;\n}\n\n.share-purchased-match-link-modal__buttons-button .icon-copy-86 {\n    background-color: unset;\n    \n}\n\n/* .share-purchased-match-link-modal__link{\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    margin-top: 24px;\n    max-width: 80%;\n    \n} */\n\n.share-purchased-match-link-modal__link.baloa-table{\n    background: var(--new-background-color);\n    padding: 11px;\n    border-radius: 4px;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .share-purchased-match-link-modal__container .modal__container {\n        width: 90vw;\n        padding: 14px;\n    }\n\n    .share-purchased-match-link-modal__buttons {\n        justify-content: center;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
